Ext.define('SA.HistogramLegendEdit', {
    alias: 'widget.histogram-legend-edit',
    extend: 'SA.ChartLegendContent',

    items: [
        {
            xtype: 'chart-legend-edit-labelled-item',
            label: 'Chart Title',

            item: {
                xtype: 'sa-text-field',
                itemId: 'chartTitleField'
            }
        }, {
            xtype: 'chart-legend-edit-labelled-text-item',
            itemId: 'yAxisTitleItem',
            label: 'Y-Axis'
        }, {
            xtype: 'chart-legend-edit-labelled-item',
            label: 'X-Axis',

            item: {
                xtype: 'combo-button',
                itemId: 'attributeDropdown',
                textField: 'text',
                valueField: 'value'
            }
        }, {
            xtype: 'chart-legend-edit-labelled-item',
            label: 'Bin Size (Bar Width)',

            item: {
                xtype: 'histogram-legend-bin-size-control',
                itemId: 'binSizeControl'
            }
        }, {
            xtype: 'chart-legend-edit-labelled-item',
            label: 'Bar Color',

            item: {
                xtype: 'color-button',
                itemId: 'barColorButton',
                width: 86
            }
        }
    ],

    initComponent() {
        this.callParent();

        this.chartTitleField = this.down('#chartTitleField');
        this.yAxisTitleItem = this.down('#yAxisTitleItem');
        this.attributeDropdown = this.down('#attributeDropdown');
        this.binSizeControl = this.down('#binSizeControl');
        this.barColorButton = this.down('#barColorButton');
    },

    initEvents() {
        this.callParent();

        this.chartTitleField.on('flush', this.onChartTitleFieldFlush, this);
        this.attributeDropdown.on('change', this.onAttributeDropdownChange, this);
        this.binSizeControl.on('change', this.onBinSizeControlChange, this);
        this.barColorButton.on('change', this.onBarColorButtonChange, this);
    },

    onAttributeDropdownChange(_, attribute) {
        this.fireEvent('change:attribute', attribute);
    },

    onBarColorButtonChange(_, color) {
        this.fireEvent('change:barColor', '#' + color);
    },

    onBinSizeControlChange(binSize) {
        this.fireEvent('change:binSize', binSize);
    },

    onChartTitleFieldFlush() {
        this.fireEvent('flush:chartTitle', this.chartTitleField.getValue());
    },

    setState(state) {
        var items = state.model.attributes.supported.ids.map(value => ({value, text: SA.data.AttributesCache.getLabel(value)})),
            selected = state.model.attributes.selected.id;

        this.chartTitleField.setValue(state.model.chartTitle);
        this.yAxisTitleItem.setText(state.model.yAxisTitle);
        this.attributeDropdown.setItemsAndValue(items, selected, {suppressEvent: true});
        this.barColorButton.setColor(state.model.barColor.replace('#', ''), {suppressEvent: true});
        this.binSizeControl.setState(state.binSize);
    }
});